@if (canShowItemsRenderingNotification()) {
  <div class="notification notification-info layout--margin-horizontal">
    <mat-icon>info</mat-icon>
    <strong class="text--info"> {{ 'renderInProgressTitle' | translate }}</strong>
    <br />
    {{ renderedItemsSoFar.value }} / {{ reportData.length }} {{ 'adviceTables' | translate }}
    {{ 'renderInProgressInformation' | translate }}
  </div>
}
<ng-container
  *ngxtFor="
    let tableReport of reportData;
    itemsAtOnce: itemsToRenderAtOnce;
    intervalLength: intervalToRenderItems;
    renderedItemsEvent: renderedItemsSoFar
  "
>
  <div class="avoid-page-break spacing--padding-top spacing--padding-bottom">
    @if (showHeaders) {
      <h2 class="text--h3 layout--margin-horizontal">
        {{ tableReport.metaData.cropName }},
        @if (!!tableReport.metaData?.cropVariety) {
          {{ tableReport.metaData.cropVariety }},
        }
        {{ tableReport.metaData.name }} ({{ tableReport.metaData.area }} Ha)
      </h2>
    }
    <mat-table [dataSource]="tableReport.fertilizationItems" class="table-wrapper">
      <ng-container matColumnDef="kg/ha">
        <mat-header-cell
          *matHeaderCellDef
          class="header-with-background flex__child flex__child-4 text--bold flex"
          style="cursor: pointer"
          [ngStyle]="{
            cursor: (isCollapsable$ | async) ? 'pointer' : 'default',
          }"
        >
          <div class="text--right spacing--margin-right"><span>Kg/Ha</span></div>
        </mat-header-cell>
        <mat-cell
          *matCellDef="let element"
          class="flex__child flex__child-4"
          [ngStyle]="{
            backgroundColor: element.source === 'total' ? '#f0f0f0' : 'inherit',
          }"
        >
          <span [class.text--bold]="element.primary">
            {{ element.source | translate }}
            @if (element.isExecuted) {
              <span> ({{ 'isAnExecutedTreatment' | translate | lowercase }})</span>
            }
            @if (element.note) {
              <span>{{ element.note }}</span>
            }
          </span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="displayDosage">
        <mat-header-cell
          *matHeaderCellDef
          class="background-color--gray4 text--bold"
          [ngStyle]="{
            cursor: (isCollapsable$ | async) ? 'pointer' : 'default',
          }"
        >
          <div class="text--right is-wide text--no-wrap">
            {{ 'dosage' | translate }}
          </div>
        </mat-header-cell>
        <mat-cell
          *matCellDef="let element"
          class="flex__child"
          [ngStyle]="{
            backgroundColor: element.source === 'total' ? '#f0f0f0' : 'inherit',
          }"
        >
          <div class="text--right is-wide">
            {{ element.displayDosage }}
          </div>
        </mat-cell>
      </ng-container>

      @for (column of elements; track $index) {
        <ng-container [matColumnDef]="column.element">
          <mat-header-cell
            class="background-color--gray4 text--bold"
            *matHeaderCellDef
            [ngStyle]="{
              cursor: (isCollapsable$ | async) ? 'pointer' : 'default',
            }"
            ><div class="text--right is-wide">{{ column.element | translate }}</div>
          </mat-header-cell>
          <mat-cell
            *matCellDef="let element"
            [class.background-color--gray5]="element.source === 'total'"
          >
            @if (element.data[column.element]) {
              <div
                class="text--right is-wide"
                [class.text--bold]="element.primary"
                [class.text--error]="element.data[column.element] < 0"
              >
                {{ element.data[column.element] | agrNumber: '1.0-' + column.numberOfDecimals }}
              </div>
            }
          </mat-cell>
        </ng-container>
      }

      <mat-header-row
        *matHeaderRowDef="displayedColumns; sticky: true"
        (click)="headerClick.emit($event)"
        data-test="fertilization-table__header"
      ></mat-header-row>
      <mat-row
        *matRowDef="let row; columns: displayedColumns"
        class="has-hover-hightlighting"
      ></mat-row>
    </mat-table>
  </div>
</ng-container>
